import React from "react";
import Dropdown from "../common/dropdown/Dropdown";
import { useSelector } from "react-redux";


// Each role key holds an array of disallowed menu item keys
const profileRestrictions = {
    BranchOwner: [],
    BranchAdmin: [],
    BranchManager: ["b"],
    BranchEmployee: ["b"],
    RestaurantOwner: ["b"],
    RestaurantAdmin: ["b"],
    SuperAdmin: ["b"],
    Customer: ["b"]
};

const ProfileDropdown = ({ onLogout }) => {
    const authIsValid = useSelector((state) => state.auth.isValid);
    const { selectedRole } = useSelector((state) => state.auth);

    // Build role string same way as ActionDropdown
    const userRole = selectedRole
        ? `${selectedRole.scope}${selectedRole.role}`
        : "Customer";

    let userDropdownList = [];
    if (authIsValid) {
        userDropdownList.push({
            key: "a",
            label: "Profile",
            link: "/profile",
        });
        userDropdownList.push({
            key: "b",
            label: "App Setting",
            link: "/setting",
        });
        userDropdownList.push({
            key: "c",
            label: "Logout",
            clickHandler: () => {
                onLogout();
            },
        });
    }

    // Map and normalize dropdown items
    const dropdownList = userDropdownList.map((item) => ({
        ...item,
        link: item.link || undefined,
        clickHandler: item.clickHandler || undefined,
    }));

    // Apply restrictions by role
    const filteredList = dropdownList.filter(
        (item) => !(profileRestrictions[userRole] || []).includes(item.key)
    );

    return (
        <Dropdown
            className="bg-primary bg-opacity-15 bg-opacity-25-hover p-2"
            buttonIcon="user"
            list={filteredList}
            align="end"
        />
    );
};

export default ProfileDropdown;
